import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { BackButton, hasPermission } from '../../../sc-utilities';
import { updateURL } from '../../../sc-utilities';
import { getMediaArrays } from '../../../sc-media/utilities';
import { Paper, Tabs, Tab, withStyles, Typography, CircularProgress, Box } from '@material-ui/core';
import OrderDetails from './OrderDetails';
import MediaGallery from '../../../sc-media/MediaGallery';
import * as action from '../../../np-core/Auth/store/authActions';
import * as actions from '../store/orderActions';
import * as groupActions from "../../../sc-group/Group/store/groupActions";
import Presets from '../../../sc-settings/Presets';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(5),
        paddingTop: theme.spacing(),
        marginBottom: theme.spacing(1.5),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    }
});

export const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={props.style}>
            {props.children}
        </Typography>
    );
};
export const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const DetailsOrderTab = props => {
    const { classes, theme, externalLoading, onUnpairedBulkExternal, onUnpairedExternal, activeCustomer, onClearState, orderLoading, permissions, order, onFetchOrder, onUpdatePresets, translations, onListReportData, onListFilePatterns, onEditOrder, activeExternalServiceAvailable, fetchGroups } = props;
    const [tabValue, setTabValue] = useState(getTabValue());
    const searchParams = new URLSearchParams(document.location.search);
    const ID = searchParams.get("OrderID");

    const [filePatterns, setFilePatterns] = useState(null);
    const [reportInformation, setReportInformation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mediaArrays, setMediaArrays] = useState({ videoArray: [], audioArray: [], imageArray: [] });
    const [deletedMedia, setDeletedMedia] = useState(false);
    const [groups, setGroups] = useState(null);

    const loadOrder = () => {
        onFetchOrder({ OrderID: ID, ActiveCustomerID: activeCustomer })
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!orderLoading || !filePatterns || !reportInformation) {
                loadOrder();

                let filePatternData = await onListFilePatterns({ ActiveCustomerID: activeCustomer });
                setFilePatterns(filePatternData || []);

                let reportInformationData = await onListReportData({ ActiveCustomerID: activeCustomer, filePatternData: filePatternData });
                setReportInformation(reportInformationData || []);

                setLoading(true);
            }
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomer, externalLoading, onClearState, orderLoading, deletedMedia, loading]);

    useEffect(() => {
        if (order && order.Media && order.Media.length > 0) {
            const media = getMediaArrays(order.Media);
            setMediaArrays({ imageArray: media.tempImages, videoArray: media.tempVideos, audioArray: media.tempAudio });
        }
    }, [order]);

    useEffect(() => {
        return () => {
            onClearState()
        };
    }, [onClearState]);

    useEffect(() => {
        const getGroups = async () => {
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomer });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_orders_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
            }
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomer, permissions]);

    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (
        <>
            <Paper className={classes.root}>
                {BackButton(translations)}
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    variant="fullWidth"
                >
                    {hasPermission(permissions, 'order_load') ? <Tab label={translations['details'] || "Details"} /> : null}
                    {hasPermission(permissions, 'order_load') ? <Tab label={translations['media'] || "Media"} /> : null}
                    {hasPermission(permissions, '*') ? <Tab label={translations['preset'] || "Preset"} /> : null}
                </Tabs>
            </Paper>

            {hasPermission(permissions, 'order_load') ?
                <TabPanel index={0} value={tabValue}>
                    <TabContainer dir={theme.direction}>
                        {order && reportInformation && filePatterns ? <OrderDetails onUnpairedExternal={onUnpairedExternal} onUnpairedBulkExternal={onUnpairedBulkExternal} orderLoading={orderLoading} translations={translations} loading={loading} permissions={permissions} reportInformation={reportInformation} filePatterns={filePatterns} onEditOrder={onEditOrder} activeExternalServiceAvailable={activeExternalServiceAvailable} activeCustomer={activeCustomer} order={order} groups={groups} />
                            : <CircularProgress size={50} />}</TabContainer> </TabPanel> : null}
            {hasPermission(permissions, 'order_load') ? <TabPanel index={1} value={tabValue}><TabContainer dir={theme.direction} style={{ padding: '8px'}}><MediaGallery orderID={ID} onRefresh={() => setDeletedMedia(!deletedMedia)} entity={translations['order'] || 'Order'} translations={translations} images={mediaArrays.imageArray} videos={mediaArrays.videoArray} audio={mediaArrays.audioArray} permissions={permissions} /></TabContainer></TabPanel> : null}
            {hasPermission(permissions, '*') ?
                <TabPanel index={2} value={tabValue} style={{ padding: 3 * 3 }}>
                    <TabContainer dir={theme.direction}><Presets loadPresets={loadOrder} updatePresets={onUpdatePresets} loadedPreset={order} idParams={{ OrderID: ID }} />
                    </TabContainer> </TabPanel> : null}
        </>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        order: state?.order?.orders?.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        orderLoading: state?.order?.orders?.editing,
        externalLoading: state.order.orders.external,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onFetchOrder: (data, options) => dispatch(actions.loadOrder(data, options)),
        onUpdatePresets: (params, options) => dispatch(actions.updatePresets(params, options)),
        onListFilePatterns: (id) => dispatch(actions.listFilePatterns(id)),
        onUnpairedBulkExternal: (data, options) => dispatch(actions.unpairedBulkExternalOrder(data, options)),
        onListReportData: (id) => dispatch(actions.listReportInformation(id)),
        onUnpairedExternal: (data, options) => dispatch(actions.unpairedExternalOrder(data, options)),
        onEditOrder: params => dispatch(actions.editOrder(params)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onClearState: () => dispatch(actions.ClearState()),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(DetailsOrderTab));